export function createUrl(page, pageSize, filter, resource) {
  const itemsPerPage = pageSize ? `&pageSize=${pageSize}` : "";

  let filterParams = "";
  if (filter && filter.tags.length > 0) {
    filter.tags.forEach(item => {
      filterParams += `&tags=${item.id}`;
    });
  }

  if (!filterParams) {
    filterParams = "&filter=null";
  }

  if (resource) {
    return `${resource}?page=${page}${itemsPerPage}${filterParams}`;
  }
  return `${window.location.pathname}?page=${page}${itemsPerPage}${filterParams}`;

}
